<script>
import NextMixinListPage from "@/components/mixins/NextMixinListPage";
import MixinActions from "@/components/mixins/MixinListActions";
import MixinUtilListCreditNote from './MixinUtilListCreditNote';
import ModalModifyDocument from './ModalModifyDocument.vue'
import * as templateDesktop from "./CreditNoteListFinalizedDesktop.vue?vue&type=template";
import * as templateMobile from "./CreditNoteListFinalizedMobile.vue?vue&type=template";
import ModalShow from "./ModalShow.vue";
import AppMenu from "../menu/AppMenu.vue";
import MixinListCreditNote from "./MixinListCreditNote";

let render = templateDesktop.render;
if (window.innerWidth < 960) {
  render = templateMobile.render;
}

export default {
  mixins: [NextMixinListPage, MixinActions, MixinUtilListCreditNote,MixinListCreditNote],
  components: { ModalShow, ModalModifyDocument,AppMenu},
  render: render,
  data() {
    return {
      title: "Notas Crédito",
      form: {},
      url: "api/v1/credit-note-finalized",
      pathBase: "/pos/credit-note",
      pathCreate: "/pos/credit-note/create",
      options: {
        page: 1,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 25, 50, 100],
        sortBy: ['created_at'],
        sortDesc: [false]
      },
      tutorial: {"default":"https:\/\/www.youtube.com\/watch?v=0lPTzQWtYow","electronic":"https:\/\/www.youtube.com\/watch?v=0lPTzQWtYow"},
      headers: [
        { title: "num", value: "index", sortable: false },
        { title: "credit_note_date", value: "credit_note_date", sortable: true, class: "th-credit_note_date", cellClass: "td-credit_note_date" },
        { title: "consecutive_credit_note", value: "consecutive_credit_note", sortable: true, class: "th-consecutive_credit_note", cellClass: "td-consecutive_credit_note" },
        { title: "invoice", value: "invoice", sortable: false, class: "th-invoice", cellClass: "td-invoice" },
        { title: "is_validate", value: "is_validate", sortable: true, class: "th-is_validate", cellClass: "td-is_validate" },
        { title: "status_dian", value: "status_dian", sortable: true, class: "th-status_dian", cellClass: "td-status_dian" },
        { title: "total_note", value: "total_note", sortable: true, class: "th-total_note", cellClass: "td-total_note" },
        { title: "_actions", value: "_actions", sortable: false }
      ],
          };
  },
  methods: {
    breadcrumbsInit() {
        this.breadcrumbs = [
            { text: this.$t('Inicio'), disabled: false, to: '/admin', 'exact-path': true },
            { text: this.$t('Ventas e Ingresos'), disabled: true, to: '', 'exact-path': true },
            { text: this.$t('Notas Crédito'), disabled: true, to: '', 'exact-path': true },
            { text: this.$t('credit-note-list-finalized'), disabled: true, to: '', 'exact-path': true },
        ];
    },
  },
};
</script>
